import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// Custom easing function for smoother scrolling
const easeInOutCubic = (t: number): number => {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2
}

const smoothScrollTo = (targetPosition: number, duration: number = 1000) => {
  const startPosition = window.pageYOffset
  const distance = targetPosition - startPosition
  let startTime: number | null = null

  const animation = (currentTime: number) => {
    if (startTime === null) startTime = currentTime
    const timeElapsed = currentTime - startTime
    const progress = Math.min(timeElapsed / duration, 1)
    const easeProgress = easeInOutCubic(progress)

    window.scrollTo(0, startPosition + distance * easeProgress)

    if (timeElapsed < duration) {
      requestAnimationFrame(animation)
    }
  }

  requestAnimationFrame(animation)
}

export function ScrollToTop() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    // Only scroll to top if there's no hash in the URL
    if (!hash) {
      smoothScrollTo(0)
    }
  }, [pathname, hash])

  return null
}
